import BreakdownCard, {
  BreakdownRow,
} from "@/components/molecules/cards/dashboard/BreakdownCard";
import DashboardMonthYearFilter from "@/components/molecules/cards/dashboard/DashboardMonthYearFilter";
import SignatureDayCalendarCard from "@/components/molecules/cards/dashboard/SignatureDayCalendarCard";
import { DashboardSignatureStatusRow } from "@/interfaces/DashboardSignatureStats";
import { useGetDashboardSignatureStatsQuery } from "@/services/admin/dashboardSignatureStats";
import { DateTime } from "luxon";
import { FC, useState } from "react";
import { Col, Row } from "react-bootstrap";

const YEAR_PALETTE = ["#9da9bb", "#27bcfd", "#2c7be5"];

const statusRows = (
  rows: DashboardSignatureStatusRow[] | undefined,
): BreakdownRow[] =>
  (rows ?? []).map((row) => ({
    key: row.statusId,
    label: row.statusName,
    color: row.backgroundColor,
    amount: row.total,
    count: row.count,
  }));

const SignatureStatsSection: FC = () => {
  const now = DateTime.now();
  const [month, setMonth] = useState<number>(now.month);
  const [year, setYear] = useState<number>(now.year);

  const { data, isFetching } = useGetDashboardSignatureStatsQuery({
    month,
    year,
  });

  const yearRows: BreakdownRow[] = (data?.byYear.rows ?? []).map(
    (row, index) => ({
      key: String(row.year),
      label:
        row.delta === null
          ? String(row.year)
          : `${row.year} (${row.delta >= 0 ? "+" : ""}${row.delta.toFixed(0)} €)`,
      color: YEAR_PALETTE[index % YEAR_PALETTE.length],
      amount: row.total,
      count: row.count,
    }),
  );

  return (
    <>
      <DashboardMonthYearFilter
        month={month}
        year={year}
        onMonthChange={setMonth}
        onYearChange={setYear}
      />
      <Row className="g-3">
        <Col md={6} xl={4}>
          <SignatureDayCalendarCard
            rows={data?.byDay.rows ?? []}
            grandTotal={data?.byDay.grandTotal ?? 0}
            grandCount={data?.byDay.grandCount ?? 0}
            month={month}
            year={year}
            isLoading={isFetching}
          />
        </Col>
        <Col md={6} xl={4}>
          <BreakdownCard
            title="Comparatif 3 années glissantes"
            description="Montant demandé signé sur ce même mois, années précédentes"
            metric="amount"
            rows={yearRows}
            grandAmount={data?.byYear.rows.reduce((sum, r) => sum + r.total, 0) ?? 0}
            grandCount={data?.byYear.rows.reduce((sum, r) => sum + r.count, 0) ?? 0}
            isLoading={isFetching}
          />
        </Col>
        <Col md={12} xl={4}>
          <BreakdownCard
            title="Devenir des dossiers signés ce mois"
            description="Statut de dossier actuel des dossiers signés le mois sélectionné"
            metric="amount"
            rows={statusRows(data?.byStatus.rows)}
            grandAmount={data?.byStatus.grandTotal}
            grandCount={data?.byStatus.grandCount ?? 0}
            isLoading={isFetching}
          />
        </Col>
      </Row>
    </>
  );
};

export default SignatureStatsSection;
